

































































































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { PiningPartsHelper, PinMessageParts, PinPartActions, } from '../../../../NewMultiMessageEditorWithMedia/types'

@Component({
  data() {
    return {
      PinMessageParts,
      PinPartActions,
    }
  }
})
export default class PinMediaActions extends Vue {
  @Prop() pinMediaHelper!: PiningPartsHelper

  action: PinPartActions | null = null

  isOpen = false

  okHandler(): void {
    if (this.pinMediaHelper.type === PinMessageParts.PinEditable && this.action !== null) {
      this.pinMediaHelper.callback(this.action)
      this.isOpen = false
      this.action = null
    }
  }

  pickPinAction(): void {
    if (this.pinMediaHelper.type === PinMessageParts.PinEditable) {
      if (this.pinMediaHelper.piningState) {
        this.action = PinPartActions.UnpinPart
      } else {
        this.action = PinPartActions.PinPart
      }
    }

    this.isOpen = true
  }

  pickCopyAction(): void {
    this.action = PinPartActions.CopyPart
    this.isOpen = true
  }
}
